<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert as wgptUseAlert } from 'dashboard/composables/wgpt';
import { useAlert } from 'dashboard/composables';

import Dialog from 'next/dialog/Dialog.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const bot = ref({});
const workflow = ref({});
const stage = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptBots/getUIFlags'];

const description = computed(() => {
  return `${t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.DELETE.CONFIRM.MESSAGE')} ${stage.value.name}?`;
});

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('wgptBotWorkflowStages/delete', {
      botId: bot.value.id,
      workflowId: workflow.value.id,
      id: stage.value.id,
    });

    useAlert(
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.DELETE.API.SUCCESS_MESSAGE')
    );
    dialogRef.value?.close();
  } catch (error) {
    wgptUseAlert(
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.DELETE.API.ERROR_MESSAGE')
    );
  }
};

const open = (selectedBot, selectedWorkflow, selectedStage) => {
  bot.value = selectedBot;
  workflow.value = selectedWorkflow;
  stage.value = selectedStage;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.DELETE.CONFIRM.TITLE')"
    :description="description"
    :confirm-button-label="
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.DELETE.CONFIRM.YES')
    "
    :cancel-button-label="
      t('WGPT_BOTS.EDIT.TABS.WORKFLOWS.STAGE.DELETE.CONFIRM.NO')
    "
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
